import {observable, action} from 'mobx';
import axiosInstance from '~/utils/axiosInstance';

class RequestStore {
  @observable loading = true;

  login() {
    const currentUrl = window.location.href;
    const computedUrl = new URL(currentUrl);
    computedUrl.searchParams.delete('redirect');
    window.location.href = `/login?redirect=${computedUrl.pathname}`; // Jump to the login app portal login page
    return false;
  }

  getSession() {
    this.setLoading(true);
    return axiosInstance
      .post('/session/get', {})
      .then(() => {
        this.setLoading(false);
      });
  }

  @action.bound
  setLoading(boo) {
    this.loading = boo;
  }
}

export default new RequestStore();
